// integer only
export const INTEGER_ONLY = /^[0-9]\d*$/;
export const CASH_ONLY = /(?=.*?\d)^\$?(([1-9]\d{0,2}(,\d{3})*)|\d+)?(\.\d{1,2})?$/;


export default {
  INTEGER_ONLY,
  CASH_ONLY
}
